import projection from '../generated/pwd503f1.json';
import { AcceptanceManifest } from '../types';
export const pwd503f1AcceptanceManifest = projection as AcceptanceManifest;
